export default "__VITE_PUBLIC_ASSET__3478c965__"